/* eslint-disable prettier/prettier */
import { useSelector } from 'react-redux';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { UploadChargebackDetails } from 'Services';
import { IAPI_ACTION, IDispatcherType, INITIAL_STATE } from 'types';
import Toasty from 'components/atoms/Toasty';

export const setAPIError = (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION): void => {
	state.loading = false;
	state.error = action.error.message || 'Something went wrong';
	Toasty.error(state.error);
};

export const uploadChargebackDetails = createAsyncThunk('post/uploadDetails', UploadChargebackDetails);

export const UploadChargebackDetailsSlice = createSlice({
	name: 'uploadChargebackDetails',
	initialState: INITIAL_STATE(),
	reducers: {
		CLEAR_ERROR: (state) => {
			state.error = '';
		},
		RESET: (state) => Object.assign(state, INITIAL_STATE()),
	},
	extraReducers: {
		[uploadChargebackDetails.pending.toString()]: (state: ReturnType<typeof INITIAL_STATE>) => {
			state.data = {};
			state.error = '';
			state.loading = true;
			state.isFetched = false;
		},
		[uploadChargebackDetails.rejected.toString()]: setAPIError,
		[uploadChargebackDetails.fulfilled.toString()]: (state: ReturnType<typeof INITIAL_STATE>, action: IAPI_ACTION<any>) => {
			const { payload } = action;

			state.loading = false;
			state.isFetched = true;
			state.error = '';
			state.data = payload;
		},
	},
});

interface IStates {
	[UploadChargebackDetailsSlice.name]: ReturnType<typeof UploadChargebackDetailsSlice.reducer>;
}

export const uploadChargebackDetailsSelector = (state: IStates): any => {
	return state[UploadChargebackDetailsSlice.name] || {};
};

export const useUploadChargebackDetails = (): any => useSelector(uploadChargebackDetailsSelector);

export const triggerUploadChargebackDetails =
	(params: any) =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(uploadChargebackDetails(params));
		return;
	};

export const resetUploadChargebackDetails =
	() =>
	async (dispatch: IDispatcherType): Promise<void> => {
		await dispatch(UploadChargebackDetailsSlice.actions.RESET());
		return;
	};
